import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

export default function ProdunitShowroom() {
    const sliderRef = useRef(null);

    const galleryRef = useRef(null);
    const [inView, setInView] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => { 
        const handleScroll = () => {
        const el = galleryRef.current;
        if (!el || inView) return;

        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
            timeoutRef.current = setTimeout(() => {
            setInView(true);
            }, 500); 
        }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 

        return () => {
        window.removeEventListener("scroll", handleScroll);
        clearTimeout(timeoutRef.current); 
        };
    }, [inView]);


    
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: true,
        cssEase: "ease",
        responsive: [
        {
            breakpoint: 767,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 2 },
        },
        ],
    };

  return (
    <>
    <section className="detailserv-style produnit-showroom">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-12">
                    <div className="line-heading">
                        <h4>Showroom Presence</h4>
                        <div ref={galleryRef} className={`lineeffect ${inView ? "showline" : ""}`}></div>
                        <span>Our Location</span>
                    </div>
                </div>

                <div className="col-lg-12">
                    <Slider {...settings} ref={sliderRef} className="showroom-slider">
                        <div>
                            <div className="showroombox">
                                <Link to={"https://maps.app.goo.gl/SVHoUXQLNPP9Rt4H8?g_st=iwb"} target="_blank">
                                    <img src="/image/showroom-1.webp" loading="lazy" className="img-responsive" alt="Showroom"/>
                                    <div>
                                        <img src="/image/locate-icon.webp" loading="lazy" alt="map"/>
                                        <span>Bahadurgarh Showroom</span>
                                    </div>
                                </Link>
                            </div>
                        </div>

                        <div>
                            <div className="showroombox">
                                <Link to={"https://maps.app.goo.gl/ryKKvZz2sv9Y8a5q7?g_st=iwb"} target="_blank">
                                    <img src="/image/showroom-2.webp" loading="lazy" className="img-responsive" alt="Showroom"/>
                                    <div>
                                        <img src="/image/locate-icon.webp" loading="lazy" alt="map"/>
                                        <span>Gurgaon Showroom</span>
                                    </div>
                                </Link>
                            </div>
                        </div>

                        <div>
                            <div className="showroombox">
                                <Link to={"https://maps.app.goo.gl/i12qUwttua2ccyL66?g_st=iwb"} target="_blank">
                                    <img src="/image/showroom-4.webp" loading="lazy" className="img-responsive" alt="Showroom"/>
                                    <div>
                                        <img src="/image/locate-icon.webp" loading="lazy" alt="map"/>
                                        <span>Panipat Showroom</span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </Slider>
                </div>

            </div>
        </div>
    </section>             
    </>
  )
}
